// export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : ''; not needed because we are using proxy in package.json
export const BASE_URL = '';
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
